import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, switchMap, withLatestFrom } from "rxjs/operators";

import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { FailState } from "../../models/fail-state";
import { VendorRolesState } from "../../models/vendor-admin/vendor-roles.state";
import { AppState } from "../../reducers";
import { VendorAdminSelectors } from "../../selectors/vendor-admin.selectors";

@Injectable()
export class VendorRolesGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.vendorRoles.get),
			withLatestFrom(this.store.select(VendorAdminSelectors.vendorRoles)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(VendorAdminActions.vendorRoles.getSuccess(state))
					: of(VendorAdminActions.vendorRoles.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.vendorRoles.getApi),
			switchMap(() =>
				this.vendorAdminService.getVendorRoles().pipe(
					switchMap((roles) => of(VendorAdminActions.vendorRoles.getSuccess({ roles }))),
					catchError((error) =>
						of(VendorAdminActions.vendorRoles.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private actions: Actions,
		private vendorAdminService: VendorAdminService
	) {}

	private canUseStoreValue(state: VendorRolesState): boolean {
		return !_.has(state, "error") && !state.loading && !_.has(state, "roles");
	}
}
